export default {
    login_register: 'Вход/Регистрация',
    booking_confirmation_title: 'Потвърждение на резервацията',
    booking_confirmation_body: 'Благодарим Ви за вашата резервация. Моля, вижте детайлите за потвърждение по-долу.',
    insurance_requirements_modal_disclaimer: `Като правя тази резервация, потвърждавам, че: За последните 5 години нямам присъди за 
        престъпления или нарушения в пътното движение. Не ми е отказвана предложена застраховка, не ми е прекратена полицата или отказано 
        обновление, нито съм бил принуден да плащам повишена премия или ми са налагани специални условия от страна на нито една застрахователна 
        компания. Не съм бил лишаван от право на управление. Нямам актуални присъди или полицейско разследване. За последните 5 години нямам 
        присъди за престъпления, свързани с кражби, измами или нечестност. Не страдам от недостатъчно зрение или слух (не коригирани с очила 
        или слухов апарат), сърдечно заболяване, диабет, епилепсия или физически или умствен недъг от какъвто и да е вид. За последните 5 
        години нямам никакви пътни инциденти. Моля, кликнете {0}, ако не отговаряте на тези изисквания.`,
    insurance_requirements_here: 'тук',
    insurance_requirements: 'Прочетох и разбрах {0}',
    ir: 'Изисквания за застраховка',
    location: 'Местоположение',
    pickup_location: 'Място за вземане',
    dropoff_location: 'Място за връщане',
    vehicle: 'Превозно средство',
    pickup_and_dropoff: 'Вземане и връщане (местно време)',
    view_voucher: 'Преглед на ваучер',
    identity_verification_body: 'Ще трябва да потвърдите вашата самоличност, преди да вземете автомобила',
    identity_verification_title: 'Потвърждение на самоличността',
    search_again: 'Търсене отново',
    refrigerated: 'хладилник',
    aircon_lower: 'климатик',
    aircon: 'Климатик',
    refrigeration: 'Охлаждане',
    not_available: 'Drive & Go в момента е достъпен само за хора с документи за самоличност и шофьорска книжка от следните държави.',
    check_if_included: 'Проверете дали вашата държава е включена.',
    included_in_booking: 'Включено в тази резервация',
    cdw_with_excess: 'CDW със самозастраховка',
    theft_protection: 'Застраховка от кражба със самозастраховка',
    risk_reduction: 'Намаляване на риска',
    free_extras: 'Имате право на две безплатни допълнителни <br /> с тази резервация.',
    continue: 'Продължи',
    luggage_large_short_label: 'L',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'S',
    luggage_large_long_label: 'голям',
    luggage_medium_long_label: 'среден',
    luggage_small_long_label: 'малък',
    fuel_unspecified_label: 'неопределено',
    transmission_manual_label: 'Ръчна',
    transmission_automatic_label: 'Автоматична',
    make_a_booking: 'Направете резервация',
    pickup_date: 'Дата на вземане',
    dropoff_date: 'Дата на връщане',
    driver_age: 'Шофьор между 30 и 65 години',
    enter_driver_age: 'Моля, въведете възрастта на шофьора',
    promo_code: 'Промо код',
    search: 'Търсене',
    dropoff_date_cannot_be_before_pickup_date: 'Дата на връщане не може да бъде преди датата на вземане',
    pickup_date_cannot_be_in_the_past: 'Дата на вземане не може да бъде в миналото',
    pickup_time_cannot_be_in_the_past: 'Времето за вземане не може да бъде в миналото',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Времето за връщане трябва да бъде по-късно от времето за вземане, ако са в същия ден',
    vehicle_filters: 'Филтри за превозно средство',
    reset: 'Нулиране',
    transmission: 'Трансмисия',
    all: 'Всички',
    manual: 'Ръчна',
    auto: 'Автоматична',
    passengers: 'Пътници',
    vehicle_type: 'Вид на превозното средство',
    filter: 'Филтър',
    vehicle_search: 'Търсене на превозно средство',
    edit: 'Редактиране',
    no_results: 'Няма резултати, отговарящи на критериите на филтъра.',
    small_cars: 'Малки автомобили',
    medium_cars: 'Средни автомобили',
    large_cars: 'Големи автомобили',
    estate_cars: 'Комбита',
    suvs: 'SUV',
    mpvs: 'Миниванове',
    vans: 'Ванове',
    camper_vans: 'Каравани',
    premium: 'Премиум',
    unspecified: 'неопределено',
    large: 'голям',
    medium: 'среден',
    small: 'малък',
    automatic: 'автоматичен',
    you_have_been_refunded: 'Вие получихте възстановяване на средства.',
    please_customer_service: 'За да направите резервация, моля, свържете се с нашата клиентска услуга.',
    contact_customer_service: 'Свържете се с клиентската услуга',
    booking_failed: 'Вашата резервация не можа да бъде обработена в момента.',
    summary: 'Резюме',
    reforestation_and_protection: 'Подкрепа на залесяването и защитата на дъждовния горски комплекс в Коста Рика',
    cost_of_rental: 'Цена на наема',
    to_pay_now: 'Да се плати сега',
    greenheart_donation: 'Дарение за "Зелено сърце"',
    total_cost: 'Обща цена на наема',
    tc_agreement: 'Прочетох и разбрах {0}.',
    tc: 'условията и положенията',
    receive_offers: 'Бих желал да получавам специални оферти по имейл.',
    donate: 'Да, бих искал да направя дарение от {amount}',
    pay_now: 'Плати {amount} сега',
    driver_details: 'Данни на шофьора',
    complete_driver_details: 'Моля, попълнете данните на шофьора.',
    are_you_the_driver: 'Вие сте ли шофьорът?',
    have_an_account: 'Вече имате профил?',
    login: 'Вход',
    or: 'или',
    first_name: 'Име на шофьора',
    last_name: 'Фамилия на шофьора',
    email: 'Имейл адрес',
    phone_number: 'Мобилен телефонен номер',
    unable_to_save_driver_information: 'Неуспешно запазване на информацията за шофьора. Моля, опитайте отново.',
    pay_online_now: 'Плати онлайн сега',
    day: 'Ден',
    choose_location: 'Изберете местоположение',
    location_not_found: 'Съжаляваме, но не можем да намерим желаното местоположение.',
    add: 'Добави',
    remove: 'Премахни',
    free_extra: 'Безплатен екстра',
    free: 'БЕЗПЛАТНО!',
    fast_track_notice: 'За тази услуга важат ограничения за произхода на документите. Тя е достъпна само за хора с документи от',
    complete_booking: 'Завършете резервацията',
    choose_card: 'Моля, изберете карта или добавете нова.',
    add_billing_details: 'Моля, добавете данни за плащане.',
    card_number: 'Номер на карта',
    card_holder_name: 'Име на карта',
    card_exp: 'MM / YY',
    card_cvc: 'CVC',
    save_card: 'Запазване на картата?',
    amount_charged: 'На вашата карта ще бъде таксувано',
    payment_confirmation: 'Потвърдете резервацията и платете',
    payment_methods: 'налични начини на плащане',
    use_saved_card: 'x използвай запазената карта',
    use_different_card: '+ използвай друга карта',
    book_now: 'Запазете сега',
    minimum_age: 'Само за лица над {age} години',
    excess_liability: 'Отговорност с излишък',
    security_deposit: 'Депозит за гаранция',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Както получено, така и върнато',
    full_to_full: 'Пълен до пълен',
    miles_per_rental: '{mileage} безплатни мили на прокат',
    km_per_rental: '{mileage} безплатни километри на прокат',
    unlimited_mileage: 'Неограничени мили',
    unlimited_mileage_km: 'Неограничени километри',
    non_amendable: 'Неизменяема',
    non_refundable: 'Неразплащаема',
    free_cancellation_until: 'Безплатно анулиране до',
    cancellation_in_line_with: 'Отмяна в съответствие с',
    tcs: 'Условия и правила',
    free_extras_on_collection: 'Две безплатни допълнителни опции при получаване',
    glass_and_tyres_covered: 'Покритие на стъклата и гумите',
    number_of_passengers: 'Брой пътници',
    number_of_bags: 'Брой багаж',
    fuel_type: 'Тип гориво',
    co2: 'CO2',
    book_type: 'Резервирай {type}',
    processing: 'Обработка',
    actual_price: 'Фактическа цена',
    tooltip: 'Цената в {currencyCode} е ориентировъчна, базирана на обменен курс, цената в {currency} е обвързваща.',
    deposit: 'Депозит',
    pay_online: 'Плати онлайн сега',
    pay_online_without_extras: 'Цена на наема',
    extras_on_arrival: 'Допълнителни опции при пристигане',
    insurance_on_arrival: 'Редуциране на риска - Плати при пристигане',
    insurance_online: 'Редуциране на риска - Плати сега',
    extras_online: 'Допълнителни опции - Плати сега',
    green_heart_donation: 'Дарение Green Heart',
    why_use_drive_and_go: 'Защо използвате Drive & Go?',
    straight_to_car: 'Директно към автомобила',
    no_queues: 'Няма опашки',
    self_checkout: 'Самостоятелно плащане',
    cant_lose_key: 'Не можете да загубите ключа',
    online_id_check: 'Онлайн проверка на самоличността',
    phone_as_key: 'Телефон като ключ',
    premiumplus_benefits_includes: 'Включени са и предимствата на Premium Plus+',
    book_drive_go: 'Резервирайте Drive & Go',
    distance_allowance: 'Разрешено разстояние',
    duration: 'Продължителност',
    view_more_bookings: 'Вижте още резервации',
    to_pay_on_arrival: 'Да се заплати при пристигане',
    pay_on_arrival: 'Плати при пристигане',
    unlimited: 'Неограничено',
    return_date: 'Дата на връщане',
    postcode: 'Пощенски код',
    country: 'Държава',
    drive_and_go: {
        drive_and_go: 'Карам и отивам',
        available_countries: 'Карам & Отивам е наличен само за хора с лични документи за самоличност и шофьорска книжка от следните държави:',
        drive_and_go_today: 'Резервация за Карам & Отивам днес!',
        drive_and_go_shortened: 'Карам & Отивам',
        why_use_drive_and_go: 'Защо избирате Карам & Отивам?',
        straight_to_car: 'Директно до автомобила',
        no_queues: 'Няма опашки',
        self_checkout: 'Самообслужване',
        cannot_lose_the_key: 'Не може да загубите ключа',
        online_id_check: 'Онлайн проверка на самоличност',
        phone_as_a_key: 'Телефон като ключ',
        premium_plus_benefits_also_included: 'Включени са и предимствата на Премиум Плюс+',
        book_drive_and_go: 'Резервирай Карам & Отивам'
    },
    my_bookings: "Моите резервации",
    no_bookings: "Няма резервации",
    my_profile: 'Моят профил',
    no_bookings_to_display: 'Няма резервации за показване.',
    search_great_car_rental_deals: "Търсете отлични оферти за наем на автомобил за вашето следващо пътуване.",
    odometer_at_collection: 'Километраж при получаване',
    fuel_at_collection: 'Гориво при получаване',
    start_check_in: 'Започнете онлайн регистрацията',
    start_collection: 'Започнете получаването',
    recent_bookings: 'Скорошни резервации',
    damage: {
        updated_damage_report_submitted: 'Актуализиран доклад за повреди е изпратен. Член от нашия екип за обслужване на клиенти ще се свърже с вас, ако е необходимо.',
        add_additional_damage: 'Добавяне на допълнителна повреда',
        you_may_report_additional_damage_up_to: 'Можете да докладвате допълнителни повреди до 24 часа след връщане на превозното средство',
        specify_damage: 'Уточнете повредата',
        please_choose_the_area_and_type_of_damage: 'Моля, изберете областта и типа на повредата',
        type_of_damage: 'Тип на повредата',
        is_this_more_than_5_cm: 'Това ли е повече от 5 см?',
        please_take_or_select_a_photo: 'Моля, направете или изберете снимка',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Моля, направете снимка, като се уверите, че повредата е ясно видима',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: 'Ако е необходимо, можете да добавите още една снимка, като изберете иконата за добавяне на друга снимка',
        save_image: 'Запазване на изображение',
        save_images: 'Запазване на изображения',
        damage_saved_successfully: 'Повредата е успешно запазена',
        add_photo: 'Добавяне на снимка'
    },
    checkout: {
        start_collection: 'Започнете събирането',
        collect_vehicle: 'Съберете превозното средство',
        we_will_let_you_know_the_details: 'Ще ви уведомим за местоположението и подробностите, за да можете да намерите наемното превозно средство.',
        inspect: 'Осмотрете',
        we_will_ask_for_four_photos_from_each_corner: 'Ще поискаме четири снимки от всеки ъгъл на превозното средство, заедно с всяка нова повреда, която не е вече включена.',
        fuel_and_milage: 'Гориво и пробег',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Потвърждавате показанията на километража и горивото в началото на наемането ви.',
        sign: 'Подпишете',
        sign_the_rental_agreement: 'Подпишете наемния договор.',
        away_you_go: 'Отивате',
        you_are_free_to_take_to_the_road: 'Свободни сте да тръгнете по пътя!',
        collect_your_vehicle: 'Съберете своето превозно средство',
        get_directions: 'Получете насоки',
        hide_directions: 'Скрий насоките',
        local_time: 'местно време',
        tel: 'Тел',
        getting_to_the_location: 'Пристигане на мястото',
        get_vehicle_details: 'Получете данни за превозното средство',
        view_map: 'Преглед на картата',
        unlock_vehicle_and_continue: 'Отключете превозното средство и продължете',
        unable_to_connect_to_vehicle: 'Не може да се осъществи връзка с превозното средство',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Не успяхме да се свържем с превозното средство - моля, проверете дали сте до правилното превозно средство и опитайте отново.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Не успяхме да намерим резервацията на превозното средство. Моля, опитайте отново по-късно.',
        odometer_and_fuel: 'Километраж и гориво',
        odometer: 'Километраж',
        please_confirm_the_odometer_and_fuel_readings: 'Моля, потвърдете показанията на километража и горивото, ако е възможно.',
        the_odometer_field_is_required: 'Полето за километража е задължително',
        and_must_be_greater_than_the_checkout_odometer: 'и трябва да бъде по-голямо от километража при изваждането',
        confirm: 'Потвърдете',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Моля, направете снимка от всеки ъгъл на превозното средство',
        pre_existing_damage: 'Съществуващи повреди',
        no_pre_existing_damage: 'Няма съществуващи повреди.',
        new_damage: 'Нови повреди',
        add_additional_damage: 'Добавете допълнителна повреда',
        no_new_damage_to_report: 'Няма нови повреди за докладване',
        checkout_complete: 'Излизането е завършено',
        start_rental: 'Започнете наемането',
        congratulations_name_it_is_time_to_take_to_the_road: 'Поздравления, {customer_name}, е време да тръгнете по пътя!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Не можем да завършим процеса на излизане с вашия автомобил.',
        please_do_the_following: 'Моля, направете следното',
        remove_all_belonging_and_lock_the_vehicle: 'Премахнете всички вещи и заключете превозното средство.',
        lock_vehicle: 'Заключете превозното средство',
        once_you_have_contacted_customer_services: 'След като се свържете с клиентските услуги',
        vehicle_location: 'Местоположение на превозното средство',
        collect_your: 'Съберете своето',
        from: 'от',
        key_in_glove_box: 'ключът се намира във вътрешния отдел на ръкавицата',

        keyholder: {
            not_detected: 'Ключът не е открит в държача за ключове',
            not_detected_please_try_again: 'Моля, поставете ключа си в държача за ключове и опитайте отново.',                
            not_installed: 'Държачът за ключове не е инсталиран',
            not_installed_please_contact_customer_service: 'Държачът за ключове не е инсталиран, моля, свържете се с клиентската услуга.',
        },
        keyring: {
            look_up_failed: 'Неуспешно търсене на ключодържателя',
            look_up_failed_please_contact_customer_service: 'Неуспешно търсене на ключодържателя, моля, свържете се с клиентската услуга.',
        },
        key: {
            invalid: 'Невалиден ключ',
            invalid_please_contact_customer_service: 'Вашият ключ е невалиден, моля, свържете се с клиентската услуга.',
            expired: 'Ключът е изтекъл',
            expired__please_contact_customer_service: 'Вашият ключ е изтекъл, моля, свържете се с клиентската услуга.',
        }
    },
    checkin: {
        start_check_in: 'Започнете проверката на превозното средство',
        vehicle_location: 'Местоположение на превозното средство',
        tell_us_where_you_have_parked: 'Кажете ни къде сте паркирали превозното средство.',
        fuel_and_milage: 'Гориво и пробег',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Вие потвърждавате показанията на одометъра и горивото в края на наема.',
        inspect: 'Осмотрете',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Ще поискаме четири снимки от всяка страна на превозното средство, заедно с всякаква нова повреда, причинена по време на наема.',
        lock: 'Заключете',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Проверете дали сте оставили лични вещи и заключете превозното средство.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Моля, кажете ни къде сте паркирали превозното средство.',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Веднъж, когато превозното средство е заключено, няма да можете да го отключите отново.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, моля, проверете дали сте оставили лични вещи, заключете превозното средство и, при необходимост, върнете физическия ключ на държача на ключовете.',
        lock_vehicle: 'Заключете превозното средство',
        complete_check_in: 'Завършете проверката на превозното средство',
        inspection: 'Осмотр',
        complete_vehicle_check_in: 'Завършете проверката на превозното средство',
        we_are_unable_to_complete_your_vehicle_check_in: 'Не можем да завършим проверката на вашето превозно средство.',
        please_contact_customer_services: 'Моля, свържете се с клиентската услуга.',
        once_you_have_contacted_customer_services: 'След като се свържете с клиентската услуга',
        please_amend_odometer_to_be_greater_than: 'Моля, коригирайте стойността на одометъра, така че да бъде по-голяма от {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Договор за наем',
        agreement_between: 'Споразумение между',
        and: 'и',
        sign_rental_agreement: 'Подпишете договора за наем',
        i_have_read_and_understood_the_terms_and_conditions: 'Прочел съм и разбрал Общите условия и приемам състоянието на превозното средство',
    },
    additional_options: 'Допълнителни опции',
    booking_details: 'Детайли за резервацията',
    price_for_x_days: 'Цена за {qty_of_days} ден | Цена за {qty_of_days} дни',
    cancelled: 'Отказано',
    upcoming: 'Предстоящо',
    active: 'Активно',
    full_insurance_no_deposit: 'Пълно застраховане и никакви депозити',
    excess: '{amount} франшиза',
    deposit: '{amount} депозит',
    included_daily_distance: '{distance} {unit} на ден',
    miles: 'мили',
    kilometers: 'километри',
    collection_details_title: 'Детайли за получаване',
    collection_details_not_found: 'Няма дефинирани детайли за получаване на това място',
    free_cancellation: 'Безплатно отказване',
    no_deposit: 'Без депозит',
    benefit_from: 'Възползвайте се от',
    for_only_per_day: 'Само за {price} на ден',
    upgrade_mee: 'UpgradeMee'
}
